import React, { useRef, useEffect, useState } from "react";
import Layout from "../components/Layout";
import Sectiontitle from "../components/Sectiontitle";
import Card from "../components/Card";
import BgDotGrid from "../components/BgDotGrid";
import Slider from "react-slick";
import LineIcon from "react-lineicons";
import { sliderSettings } from "../constants/constants";

sliderSettings.infinite = false;

function CommunicationsMediaAndTechnology() {
  const sliderRef = useRef();
  const [apps, setApps] = useState([]);

  useEffect(() => {
    fetch("/apps/industry/Communications,%20Media%20&%20Technology")
      .then(r => r.json())
      .then(data => setApps(data))
      .catch(() => {});
  }, []);

  const items = apps.Items || [];

  return (
    <Layout>
      <div className="mi-comms mi-section">
        <BgDotGrid />
        <div className="content-container">
          <Sectiontitle title={`Communications, Media & Technology (${items.length})`} />
          <div className="slider-wrapper">
            <button className="slider-control" onClick={() => sliderRef.current.slickPrev()}>
              {items.length > 3 ? <LineIcon name="chevron-left" /> : false}
            </button>
            <Slider ref={sliderRef} className="mi-card-slider" {...sliderSettings}>
              {items.map((item, index) => <Card key={index} {...item} />)}
            </Slider>
            <button className="slider-control" onClick={() => sliderRef.current.slickNext()}>
              {items.length > 3 ? <LineIcon name="chevron-right" /> : false}
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default CommunicationsMediaAndTechnology;
